import type { ProductToolFlowType } from '@forgd/contract/types'
import { AnalyticsEventEnum, ProductToolIdSchema } from '@forgd/contract/types'

export function useFlowTracking() {
  const route = useRoute()
  const { capture } = useAnalytics()

  function captureFlowCompleted(flowName: ProductToolFlowType) {
    const toolResult = ProductToolIdSchema.safeParse(route.meta.productTool)
    if (!toolResult.success) {
      return
    }

    const subTool = typeof route.meta.productSubTool === 'string'
      ? route.meta.productSubTool
      : undefined

    capture(AnalyticsEventEnum.FlowCompleted, {
      path: route.fullPath,
      product_tool: toolResult.data,
      flow_name: flowName,
      ...(subTool ? { product_sub_tool: subTool } : {}),
    })
  }

  return { captureFlowCompleted }
}
